import styled from "styled-components";
import React from "react";
import { Link } from "react-router-dom";


export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 1rem 2rem 6rem 2rem;
`;

export const AboutInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const GroupImg = styled.img`
  width: 100%;
  max-width: 290px;
  height: auto;
  display: block;
  position: relative;

  /* Responsive scaling */
  @media (min-width: 425px) {
    max-width: 290px;
    margin-left: -12px;
  }

  /* Responsive scaling */
  @media (min-width: 768px) {
    max-width: 400px;
    margin-left: -12px;
  }

  @media (min-width: 1024px) {
    max-width: 800px;
    margin-left: -12px;
  }
`;


export const ImgContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 0.2rem;
  max-width: 100%;

  /* Responsive scaling */
  @media (min-width: 424px) {
    flex-direction: row;
    gap: 0.3rem;
  }

  /* Responsive scaling */
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 3rem;
    max-width: 600px;
  }

  @media (min-width: 1024px) {
    gap: 4rem;
    max-width: 680px;
  }
`;

export const AboutHead1 = styled.h1`
  font-size: 26px;
  color: var(--maindark);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 1rem 0 1rem 0;

  @media screen and (min-width: 768px) {
    font-size: 28px;
    margin: 2rem 0 1rem 0;
  }

  @media screen and (min-width: 1024px) {
    font-size: 32px;
    margin: 2rem 0 1rem 0;
  }
`;

export const AboutIntroParagraph = styled.p`
  font-size: 16px;
  font-weight: 300;
  color: var(--maindark);
  margin: 0;
  max-width: 800px;

  @media screen and (min-width: 768px) {
    font-size: 18px;
    line-height: 1.5;
    font-weight: 300;
  }
`;

interface MoreButtonProps {
  to?: string;
}

const ReadMoreButton = styled(Link)<MoreButtonProps>`
  text-align: center;
  border-radius: 50px;
  border: none;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  background-color: var(--bg-pink);
  color: var(--mainlight);
  font-weight: 700;
  font-size: 14px;
  padding: 10px auto;
  width: 110px;
  margin-top: 40px;
  overflow: hidden;
  position: relative;
  z-index: 0;
  transition: transform 0.2s ease;
  padding: 12px 0;

  &:hover {
    color: var(--mainlight);
    z-index: 1;
    background-color: var(--accent-pink);
    transform: scale(1.04);
    transition: transform 0.2s ease-in-out;
  }

  &:active {
    transform: scale(0.95);
    border: none;
    background-color: var(--maindark);
    color: var(--mainlight);
  }

  /* Pseudo-element for wave effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 300%;
    height: 100%;
    background: var(--bg-pink);
    z-index: -1;
    transform: skewX(60deg);
    transition: transform 0.5s ease;
  }

  /* Hover: Move the wave across */
  &:hover::before {
    transform: translateX(100%) skewX(-30deg);
  }
`;

// Component definition
export const ReadMore: React.FC<MoreButtonProps> = ({ to = "/" }) => {
  return <ReadMoreButton to={to}>Läs mer</ReadMoreButton>;
};
